import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const jiraBusinessBoardRoute: InvariantJiraRoute = {
	name: 'classic-business-board',
	exact: true,
	path: '/jira/core/projects/:projectKey/board/:itemId?',
};
